export const SET_NOTICIAS = 'SET_NOTICIAS';
export const SET_LABORATORIOS = 'SET_LABORATORIOS';
export const SET_OPCIONES_MENU = 'SET_OPCIONES_MENU';
export const SET_BANNERS = 'SET_BANNERS';
export const SET_SERVICIOS = 'SET_SERVICIOS';
export const SET_SEDES = 'SET_SEDES';
export const SET_QUIENES_SOMOS = 'SET_QUIENES_SOMOS';
export const SET_QUIENES_SOMOS_BTN = 'SET_QUIENES_SOMOS_BTN';
export const SET_POLITICAS = 'SET_POLITICAS';
export const SET_MODELO_ATENCION = 'SET_MODELO_ATENCION';
export const SET_CONTACTO = 'SET_CONTACTO';
